import React, { Fragment, useState } from 'react';
import PropTypes from "prop-types";
import SCheckbox from '../ui/SCheckbox';
import { isChecked } from '../../utils/controls';
import { TogglePrice } from './styled';
import RubleLightIcon from '../icons/RubleLightIcon';
import InfoIcon from '../icons/InfoIcon';
import RitModal from '../RitModal';

const CheckboxComponent = (options) => {
    const {
        disabled,
        name,
        label,
        input,
        values,
        price,
        defaultValue,
    } = options;

    const attrPrice = (values && values[true].price) || price;
    const { value } = input;

    let priceLabel;
    if (attrPrice) {
        priceLabel = (
            <TogglePrice>
                {attrPrice}&#160;
                <RubleLightIcon size={9} color='currentColor'/>
            </TogglePrice>
        );
    }

    let disabedClassName = '';
    if (disabled) {
        disabedClassName = ' b-checkbox_disabled'
    }

    let checkedLabelClassName = '';
    if (isChecked(value)) {
        checkedLabelClassName = ' b-checkbox_checked';
    }

    const [isModalOpened, setIsModalOpened] = useState(false);
    const toggleModal = () => {
        setIsModalOpened(!isModalOpened);
    }
    
    return (
        <div style={{position: 'relative'}}>
            <label
                className={
                    `b-checkbox${checkedLabelClassName}${disabedClassName}`
                }
                htmlFor={input.name}
            >
                <div className='b-checkbox__wrapper'>
                    <SCheckbox
                        id={`${input.name}`}
                        name={name}
                        size="small"
                        checked={isChecked(value)}
                        onCheck={async (e, data) => {
                            input.onChange(data)
                        }}
                        onBlur={() => {
                            input.onBlur()
                        }}
                        label={label}
                        disabled={disabled}
                    />
                    {priceLabel}
                </div>
            </label>
            {input.name == 'suspended' && 
                <Fragment>
                    <div className='b-checkbox__about'>
                        <InfoIcon onClick={toggleModal} />
                    </div>
                    <RitModal
                        isOpened={isModalOpened}
                        onClose={toggleModal}
                        title='Premium'
                        titledWeight={'bold'}
                        closeOnEsc={true}
                    >
                        <div className='b-checkbox__about-text'>
                            Опция включает в себя набор уникальных дополнений: перламутровые пуговицы, ластовица, ручная пришивка пуговиц, увеличенная частота стяжка.
                        </div>
                    </RitModal>
                </Fragment>
            }
	    {input.name == 'collarDecor' &&
		<Fragment>
		    <div className='b-checkbox__about'>
		        <InfoIcon onClick={toggleModal} />
		    </div>
		    <RitModal
		        isOpened={isModalOpened}
		        onClose={toggleModal}
		        title='Ручная отделка воротника'
                        titledWeight={'bold'}
                        closeOnEsc={true}
                    >
                        <div className='b-checkbox__about-text'>
                           Опция включает в себя ручную отделку воротника.
                        </div>
                    </RitModal>
                </Fragment>
           }
           {input.name == 'cuffDecor' &&
                <Fragment>
                    <div className='b-checkbox__about'>
                        <InfoIcon onClick={toggleModal} />
                    </div>
                    <RitModal
                        isOpened={isModalOpened}
                        onClose={toggleModal}
                        title='Ручная отделка манжет'
                        titledWeight={'bold'}
                        closeOnEsc={true}
                    >
                        <div className='b-checkbox__about-text'>
                              Опция включает в себя ручную отделку манжет .
                        </div>
                    </RitModal>
                </Fragment>
	  }

        </div>
    )
}

CheckboxComponent.propTypes = {
    disabled: PropTypes.any.isRequired,
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    price: PropTypes.any,
}

export default CheckboxComponent;
